import { render, staticRenderFns } from "./loadgreensupplier.vue?vue&type=template&id=06ee98b2&scoped=true&"
import script from "./loadgreensupplier.vue?vue&type=script&lang=js&"
export * from "./loadgreensupplier.vue?vue&type=script&lang=js&"
import style0 from "./loadgreensupplier.vue?vue&type=style&index=0&id=06ee98b2&lang=scss&scoped=true&"
import style1 from "./loadgreensupplier.vue?vue&type=style&index=1&id=06ee98b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee98b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ee98b2')) {
      api.createRecord('06ee98b2', component.options)
    } else {
      api.reload('06ee98b2', component.options)
    }
    module.hot.accept("./loadgreensupplier.vue?vue&type=template&id=06ee98b2&scoped=true&", function () {
      api.rerender('06ee98b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliergreen/loadgreensupplier.vue"
export default component.exports